import moment from 'moment'
import { ShiftTemplateResponse, ShiftTemplateResponseItem } from '@/types/service-response'
import { KindOfShift } from '@/types/enums'

export class ShiftTemplate {
  private constructor (
    readonly id: number,
    readonly kindOfShift: KindOfShift,
    readonly code: string,
    readonly description: string,
    readonly budget: number,
    readonly startDate: Date,
    readonly endDate: Date,
  ) {}

  public static createListFromResponse (data: ShiftTemplateResponse): Array<ShiftTemplate> {
    return data.map((item: ShiftTemplateResponseItem) => {
      return new ShiftTemplate(
        item.ID,
        ShiftTemplate.resolveKindOfShift(item.TypeOfShift),
        item.Code,
        item.Bezeichnung,
        item.Budget,
        moment(item.Start).toDate(),
        moment(item.Ende).toDate()
      )
    })
  }

  private static resolveKindOfShift (typeFromResponse: string): KindOfShift {
    if (typeFromResponse === 'QCQ Shift') {
      return KindOfShift.Qcq
    } else if (typeFromResponse === 'Free Shift') {
      return KindOfShift.Free
    }

    return KindOfShift.Unknown
  }
}
